import { createApp } from 'vue'
import App from './App.vue'
import './styles/reset.css'
import './styles/auto.css'

createApp(App).mount('#app')
